<form #form="ngForm" autocomplete="off">
    <div *ngFor="let approvalFlowStep of approvalFlowSteps; index as step" class="app-grid approver-wrapper">
        <mat-form-field class="columns-4">
            <mat-label appRemoveAriaOwns>{{ 'time-off-v3.stepIncrement' | translate: { num: step + 1 } }}</mat-label>

            <mat-select
                [(ngModel)]="approvalFlowStep.timeOffApproverTypeId"
                name="approverType-{{ step }}"
                (selectionChange)="wipeSpecificPerson($event, approvalFlowStep)"
            >
                <mat-option
                    *ngFor="let approverType of approverTypes"
                    [value]="approverType.id"
                    [disabled]="isApproverTypeUsed(approverType.id)"
                    data-test-id="approver-types"
                >
                    {{
                        approverType.name === 'Admin'
                            ? ('time-off-v3.approvalObserverTypes.allAdmins' | translate)
                            : (approverType.name | appTranslateOptions: approvalObserverTypeDisplay)
                    }}
                </mat-option>
            </mat-select>
        </mat-form-field>
        <mat-form-field
            class="columns-4 margin-left-2"
            *ngIf="approvalFlowStep.timeOffApproverTypeId === specificPersonApproverTypeId"
        >
            <mat-label>{{ 'time-off-v3.person' | translate }}</mat-label>
            <ui-employee-autocomplete
                name="specificPerson-{{ step }}"
                #specificPerson="ngModel"
                [ngModel]="getApprover(approvalFlowStep.timeOffApprover)"
                (ngModelChange)="setApproverId($event, approvalFlowStep)"
                placeholder="{{ 'time-off-v3.selectAnEmployee' | translate }}"
                [allowNone]="false"
                required
            ></ui-employee-autocomplete>
        </mat-form-field>
        <ui-button type="ghost" (click)="removeApprovalFlowStep(approvalFlowStep)">{{
            'time-off-v3.remove' | translate
        }}</ui-button>
    </div>
    <ui-button type="link" (click)="addApprovalFlowStep()" [disabled]="approvalFlowSteps.length === 4"
        >{{ 'time-off-v3.addLevelIcon' | translate }} <i class="fa fa-plus margin-left-1"></i
    ></ui-button>
</form>
